<div class="blob-background">
	<div class="blob one"></div>
	<div class="blob two"></div>
	<div class="blob three"></div>
	<div class="blob four"></div>
	<div class="blob five"></div>
	<div class="middle">
		<form>
			<div class="floating-panel">
				<div class="branded-asset-logo"></div>
				<hr>
				<div [hidden]="showMfa" class="mb-3 narrow">
					<label for="email">Email address</label>
					<input [(ngModel)]="email" id="email" name="email" type="email" autocomplete="email" placeholder="Email" class="form-control">
				</div>
				<div [hidden]="showMfa" class="mb-3 narrow">
					<label for="password">Password</label>
					<input [(ngModel)]="password" id="password" name="password" type="password" autocomplete="current-password" placeholder="Password" class="form-control">
				</div>
				@if (showMfa) {
					<div class="mb-3 narrow">
						<label for="mfa">MFA Code</label>
						<input [(ngModel)]="mfaCode" id="mfa" name="mfa_code" type="text" autocomplete="one-time-code" placeholder="6 Digit Code" class="form-control">
					</div>
				}
				<div class="button-group narrow mt-3">
					<app-action-button submit #loginButton [action]="Login" [context]="this" btnClass="full-green wider" [disabled]="!email || !password || (showMfa && !mfaCode)"
						processing="Logging in...">Log In</app-action-button>
					@if (showMfa) {
						<button type="button" class="button ms-3" (click)="CancelMfa()">Cancel</button>
					}
				</div>
				@if (!showMfa) {
					<div class="narrow">
						<a [routerLink]="['/forgot']">Forgot password?</a>
					</div>
				}
			</div>
		</form>
	</div>
</div>